import React, { FC } from "react";

import { DiscountShapeIcon } from "application/assets";
import { useAppSelector } from "application/store";
import { formatTotal } from "application/helpers/formatTotal";

import { Wrapper, AmountField } from "./styles";

const ReferralBonus: FC = () => {
  const { deal, commitment } = useAppSelector((state) => state.deal);

  const currency = deal?.investmentCurrency;
  const bonusBalance = formatTotal(commitment?.bonusBalance, currency);
  const managementFee = formatTotal(commitment?.managementFee, currency);
  const managementFeePercentage = commitment?.managementFeePercentage || 0;
  const managementFeeWithBonus = formatTotal(
    commitment?.managementFeeWithBonus,
    currency
  );

  return (
    <Wrapper className="referral-bonus">
      <AmountField className="bonus">
        <h2>
          <DiscountShapeIcon />
          Referral bonus applied:
        </h2>
        <p>{bonusBalance}</p>
      </AmountField>
      <AmountField>
        <h2>Management fee ({managementFeePercentage}%×3):</h2>
        <p>{managementFee}</p>
      </AmountField>
      <AmountField>
        <h2>Management fee after bonus:</h2>
        <p>{managementFeeWithBonus}</p>
      </AmountField>
    </Wrapper>
  );
};

export default ReferralBonus;
